/**
 * Routing Config for Subgraphs L1
 */
import { RouteConfig } from 'src/lib/routeConfig/RouteConfig';

import { subgraphsRouteConfig } from '../routes';

/**
 * Routing Config for Subgraph Configuration Page
 */
export const subgraphsConfigRouteConfig = subgraphsRouteConfig.extend(
  new RouteConfig({
    owners: ['growth'],
    definition: '/new',
  }),
);
